import { formatDateBr, formatTimeBr, validarDate } from "@utils";
import moment from "moment";

export const formatHourInput = (input: string): string => {
    if (!input?.trim()) return "";

    const digits = input.replace(/\D/g, "");
    if (digits.length <= 1) return digits;

    if (digits.length === 2) {
        const hours = parseInt(digits);
        return hours > 23 ? "23" : digits;
    }

    if (digits.length === 3) {
        const hours = parseInt(digits.slice(0, 2));
        return hours > 23 ? "23:" : `${digits.slice(0, 2)}:${digits[2]}`;
    }

    if (digits.length >= 4) {
        const hours = parseInt(digits.slice(0, 2));
        const minutes = parseInt(digits.slice(2, 4));

        if (hours > 23) return "23:59";
        if (minutes > 59) return `${digits.slice(0, 2)}:59`;

        return `${digits.slice(0, 2)}:${digits.slice(2, 4)}`;
    }

    return input;
};

export const validateDateTime = (time: string, date?: string) => {
    if (!time || !/^\d{2}:\d{2}$/.test(time)) {
        return { isValid: false, error: "" };
    }

    const [hours, minutes] = time.split(":").map(Number);

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return {
            isValid: false,
            error: "Hora inválida. Use formato HH:MM (00:00 a 23:59) para agendar a viagem"
        };
    }

    if (date) {
        const selectedDateTime = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm");

        if (!selectedDateTime.isValid()) {
            return {
                isValid: false,
                error: "Data ou hora inválidas"
            };
        }

        const now = moment();

        if (selectedDateTime.isSameOrBefore(now)) {
            return {
                isValid: false,
                error: "A data e hora selecionadas não podem ser anteriores ou iguais ao momento atual"
            };
        }
    }

    return { isValid: true, error: "" };
};


export const validateDate = (date: string) => {
    if (!validarDate(date, true)) {
        return { isValid: false, error: "Data inválida. Selecione uma data válida para agendar a viagem" };
    }
    return { isValid: true, formattedDate: formatDateBr(date, false) };
};

export const formatHourFromInput = (input: any): string => {
    return typeof input === "string"
        ? formatHourInput(input)
        : formatTimeBr(new Date(input.toString()), "HOUR_AND_MINUTES");
};

export const getInputStyle = (hasError: boolean) => ({
    border: hasError ? '2px solid #dc3545' : '1px solid #ced4da',
    borderRadius: '4px',
    transition: 'border-color 0.15s ease-in-out'
}); 